export default __webpack_public_path__ + "static/media/menu.ebdb24d8.svg";